@if (applicationState$ | async; as state) {
    <div
        class="grid grid-cols-2 gap-2 w-full text-sm space-x-14 xl:flex xl:ml-3 xl:mt-2 xl:space-x-4"
    >
        @if (state.salmonLogId) {
            <div>
                App ID:
                <span class="text-primary-800">{{ state.salmonLogId }}</span>
            </div>
        }
        @if (licenseeName$ | async; as licenseeName) {
            <div>
                Licensee:
                <span class="text-primary-800">{{ licenseeName }}</span>
            </div>
        }
        @if (shouldShowEwaStaffHeaderFields()) {
            <div>
                Credit Approved:
                <span
                    class="{{
                        state.applicationUserInformation?.isCreditApproved
                            ? 'text-success-700'
                            : 'text-error-700'
                    }}"
                >
                    {{
                        state.applicationUserInformation?.isCreditApproved
                            ? 'Yes'
                            : 'No'
                    }}
                </span>
            </div>
            <div>
                Membership:
                <span
                    class="{{
                        isActiveUserMembershipStatus(
                            state.applicationUserInformation?.membershipStatus
                        )
                            ? 'text-success-700'
                            : 'text-error-700'
                    }}"
                >
                    {{
                        getFormattedUserMembershipStatusLabel(
                            state.applicationUserInformation?.membershipStatus
                        )
                    }}
                </span>
            </div>
        } @else {
            @if (state.advisorName) {
                <div>
                    EWA Advisor:
                    <span class="text-primary-800">{{
                        state.advisorName
                    }}</span>
                </div>
            }
        }
    </div>
}
